import { useLocale } from '../../../hooks';
import { FunctionComponent } from 'react';
import { Header, Placeholder, Segment } from 'semantic-ui-react';

type Props = {
    loading?: boolean;
    title: string;
    value: string;
    total: string;
};

const InsightCard: FunctionComponent<Props> = props => {
    const { loading, title, value, total } = props;

    const labels = useLocale({
        total: 'Total',
        available: 'Available',
    });

    const placeholder = (
        <Placeholder style={{ height: '146px' }}>
            <Placeholder.Image />
        </Placeholder>
    );

    const getRemaining = () => {
        return parseInt(total) - parseInt(value);
    };

    return (
        <Segment
            style={{
                flex: 1,
                margin: 0,
                padding: 0,
                border: 0,
                overflow: 'hidden',
            }}
        >
            {(!loading && (
                <Segment basic style={{ display: 'flex', padding: 0, border: 0 }}>
                    <Segment.Group style={{ flex: 1 }}>
                        <Segment.Group style={{ margin: 0, border: 0 }}>
                            <Segment basic style={{ padding: '12px 0 0 0', border: 0 }}>
                                <Header
                                    sub
                                    textAlign='center'
                                    content={title}
                                    style={{ margin: 0, fontSize: '1rem' }}
                                />
                            </Segment>
                            <Segment basic style={{ padding: '22px 0', margin: 0, border: 0 }}>
                                <Header
                                    color={(parseInt(value) >= parseInt(total) && 'red') || 'grey'}
                                    textAlign='center'
                                    style={{ fontWeight: 800, margin: 0 }}
                                    content={
                                        <>
                                            <span style={{ fontSize: '2.8rem' }}>{value}</span>
                                            <span style={{ fontSize: '1.8rem' }}>/{total}</span>
                                        </>
                                    }
                                />
                            </Segment>
                        </Segment.Group>
                        <Segment
                            basic
                            attached='top'
                            style={{ display: 'flex', padding: 0, border: 0, borderRadius: 0 }}
                        >
                            <Segment style={{ padding: '8px 0 4px 0', margin: 0, flex: 1, borderRadius: 0 }}>
                                <Header sub as='h4' textAlign='center' content={labels.total} subheader={`${total} `} />
                            </Segment>
                            <Segment style={{ padding: '8px 0 4px 0', margin: 0, flex: 1, borderRadius: 0 }}>
                                <Header
                                    sub
                                    as='h4'
                                    textAlign='center'
                                    color={(getRemaining() <= 0 && 'red') || undefined}
                                    content={labels.available}
                                    subheader={getRemaining()}
                                />
                            </Segment>
                        </Segment>
                    </Segment.Group>
                </Segment>
            )) || <>{placeholder}</>}
        </Segment>
    );
};

export default InsightCard;
